import React, { useRef } from "react";
import Button from "components/common/Button";
import PopupModal, { PopupModalRef } from "components/common/PopupModal";
import ModalContent from "components/modals/ModalContent";
import BookingService from "services/booking";
import { useNotification } from "hooks/useNotification";
import { get } from "utils/lodash";
import cx from "classnames";

interface AcceptBookingProps {
  booking: any;
  onSuccess?: (res?: any) => void;
  className?: string;
}

export default function AcceptBooking({ booking, onSuccess, className }: AcceptBookingProps) {
  const modalRef = useRef<PopupModalRef>(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const notification = useNotification();
  const bookingId = get(booking, "id", "");

  const customerName = get(booking, "populatedUser[0].name") ||
                      get(booking, "user.name") ||
                      "khách hàng";

  const handleAccept = async () => {
    try {
      setIsLoading(true);
      const res = await BookingService.acceptedBooking({ id: bookingId });
      notification.success("Nhận khách thành công");
      modalRef.current?.close();
      onSuccess?.(res);
    } catch (error) {
      notification.error("Nhận khách thất bại");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Button
        className={className}
        variant="primary"
        size="sm"
        loading={isLoading}
        onClick={() => modalRef.current?.open()}
      >
        <span className="font-semibold">Nhận khách</span>
      </Button>
      <PopupModal ref={modalRef}>
        <ModalContent
          content={
            <label>
              Chuyển trạng thái <span className="font-semibold">Đã xác nhận</span>
              <br />
              cho khách hàng <span className="font-semibold">{customerName}</span>
            </label>
          }
          onAccept={handleAccept}
          onCancel={() => modalRef.current?.close()}
          cancelLabel="Thoát"
          acceptLabel="Xác nhận"
        />
      </PopupModal>
    </>
  );
}